import { VTextField } from 'vuetify/lib/components/VTextField';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VTextField, _vm._b({
    directives: [{
      def: Ripple,
      name: "ripple",
      rawName: "v-ripple"
    }],
    ref: "element",
    attrs: {
      "append-icon": _vm.isCopySupported ? 'fal fa-copy' : null,
      "readonly": _vm.readOnly,
      "hide-details": "",
      "data-cy": _vm.dataCy
    },
    on: {
      "click:append": function ($event) {
        return _vm.handleClickAppend($event);
      },
      "click": function ($event) {
        return _vm.handleClick($event);
      }
    }
  }, 'v-text-field', _vm.$attrs, false));
};
var staticRenderFns = [];
export { render, staticRenderFns };